import * as React from 'react';
import { FormInstance } from 'antd';
import { InputBaseModel, NodeBaseModel } from '../models';
import { NodeFormValues } from '../types';
import { InstanceUtils } from '../misc';

export default (
    form: FormInstance<NodeFormValues>,
    node: NodeBaseModel | undefined,
    setFormFieldValue: (input: InputBaseModel) => void
) => {
    const getNodeSubscriptions = React.useCallback(
        (nodeToProcess: NodeBaseModel) => {
            const subscriptions = [
                nodeToProcess.inputValueChangeSubject.subscribe(setFormFieldValue),
                nodeToProcess.inputValidationSubject.subscribe((input: InputBaseModel) =>
                    form.validateFields([input.guid])
                )
            ];

            nodeToProcess.childNodes.forEach(childNode => {
                subscriptions.push(...getNodeSubscriptions(childNode));
            });

            return subscriptions;
        },
        [setFormFieldValue, form]
    );

    React.useEffect(() => {
        if (!node) {
            return;
        }

        const subscriptions = getNodeSubscriptions(node);
        return () => subscriptions.forEach(subscription => subscription.unsubscribe());
    }, [node, getNodeSubscriptions]);

    React.useEffect(() => {
        if (!InstanceUtils.hasSectionSyncManager(node)) {
            return;
        }

        const subscription = node.inputValueChangeSubject.subscribe(input => {
            node.sectionSyncManager.processSyncRules(input);
        });

        return () => subscription.unsubscribe();
    }, [node]);
};
